module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/18-1eeaf215d5380bf2af0ae25ba394683a.png";